import { TranslationKeys } from '.';


export const lang: Record<TranslationKeys, string> = {
    show: 'Show',
    hide: 'Hide',
    'content-for': 'content for',
    'submenu-for': 'submenu for',
    'follow-us-on': 'Follow us on',
    'written-by': 'Written by',
    'all': 'All',
    'load-more': 'Load more',
    'filter-on': 'Filter on',
    'minute-read': ' minute read',
    'form-sent': 'Form sent successfully',
    'form-error': 'Something went wrong, please try again',
    'accept-terms': 'You must accept the terms and conditions',
    'first-name-invalid': 'First name is invalid',
    'last-name-invalid': 'Last name is invalid',
    'email-invalid': 'Email is invalid',
    'zip-code-invalid': 'Zip code is invalid',
    'phone-invalid': 'Phone number is invalid',
    'is-required': 'is required',
    'see-our-projects': 'See our projects',
    'news': 'News',
    'press': 'Press',
    'close-menu': 'Close menu',
    'find-something-good': 'Find something good!',
    'search-hint': 'Search here...',
    'found': 'Found',
    'hits': 'hits',
};